import APIUtils from '@spothero/utils/api';
import UserUtils from 'user/user-utils';

const AuthenticationAPI = {
    register(requestData) {
        return APIUtils.post('users/', requestData)
            .then(payload => payload.data.data.user)
            .then(UserUtils.formatPayload);
    },

    login(requestData) {
        return APIUtils.post('users/login/', requestData)
            .then(payload => payload.data.data)
            .then(UserUtils.formatPayload);
    },

    loginFacebook(requestData) {
        return APIUtils.post('users/login/facebook/', requestData)
            .then(payload => payload.data.data)
            .then(UserUtils.formatPayload);
    },

    loginGoogle(requestData) {
        return APIUtils.post('users/login/google/', requestData)
            .then(payload => payload.data.data)
            .then(UserUtils.formatPayload);
    },

    logout() {
        return APIUtils.post('users/logout/');
    },

    changeUsername(newEmail) {
        return APIUtils.post('users/me/email/', {
            email: newEmail,
        });
    },

    setPassword({token, newPassword}) {
        return APIUtils.post('users/password/', {
            reset_token: token, // eslint-disable-line camelcase
            new_password: newPassword, // eslint-disable-line camelcase
        });
    },

    resetPassword(email) {
        return APIUtils.post('users/password-reset/', {
            email,
        });
    },
};

export default AuthenticationAPI;
